/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventFreeNftCreateRequest model module.
 * @module model/EventsControllerDtoEventFreeNftCreateRequest
 * @version 1.0
 */
class EventsControllerDtoEventFreeNftCreateRequest {
    /**
     * Constructs a new <code>EventsControllerDtoEventFreeNftCreateRequest</code>.
     * @alias module:model/EventsControllerDtoEventFreeNftCreateRequest
     */
    constructor() { 
        
        EventsControllerDtoEventFreeNftCreateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventFreeNftCreateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventFreeNftCreateRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventFreeNftCreateRequest} The populated <code>EventsControllerDtoEventFreeNftCreateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventFreeNftCreateRequest();

            if (data.hasOwnProperty('mintingCode')) {
                obj['mintingCode'] = ApiClient.convertToType(data['mintingCode'], 'String');
            }
            if (data.hasOwnProperty('issuedCount')) {
                obj['issuedCount'] = ApiClient.convertToType(data['issuedCount'], 'Number');
            }
            if (data.hasOwnProperty('usedCount')) {
                obj['usedCount'] = ApiClient.convertToType(data['usedCount'], 'Number');
            }
            if (data.hasOwnProperty('beginAt')) {
                obj['beginAt'] = ApiClient.convertToType(data['beginAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventFreeNftCreateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventFreeNftCreateRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['mintingCode'] && !(typeof data['mintingCode'] === 'string' || data['mintingCode'] instanceof String)) {
            throw new Error("Expected the field `mintingCode` to be a primitive type in the JSON string but got " + data['mintingCode']);
        }

        return true;
    }


}



/**
 * @member {String} mintingCode
 */
EventsControllerDtoEventFreeNftCreateRequest.prototype['mintingCode'] = undefined;

/**
 * @member {Number} issuedCount
 */
EventsControllerDtoEventFreeNftCreateRequest.prototype['issuedCount'] = undefined;

/**
 * @member {Number} usedCount
 */
EventsControllerDtoEventFreeNftCreateRequest.prototype['usedCount'] = undefined;

/**
 * @member {Date} beginAt
 */
EventsControllerDtoEventFreeNftCreateRequest.prototype['beginAt'] = undefined;

/**
 * @member {Date} endAt
 */
EventsControllerDtoEventFreeNftCreateRequest.prototype['endAt'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoEventFreeNftCreateRequest.prototype['createdAt'] = undefined;






export default EventsControllerDtoEventFreeNftCreateRequest;

